import script from "./Img.vue?vue&type=script&lang=ts&setup=true"
export * from "./Img.vue?vue&type=script&lang=ts&setup=true"

import "./Img.vue?vue&type=style&index=0&id=5ce8cc6d&lang=less"

const __exports__ = script;

export default __exports__